import React from 'react';
import { Navigate } from 'react-router-dom';
import roles from '../../constants/roles';
import { useAuth } from '../../contexts/Auth';
import Spinner from '../Layout/Loading/Spinner';

const PrivateRouteOnlySecretary: React.FC<{
  element: React.ReactElement;
  publicRedirect?: string;
}> = (props) => {
  const [{ appLoaded, isAuthenticated, profile }, dispatch] = useAuth();
  const { element: PrivateElement } = props;

  if (appLoaded) {
    if (
      isAuthenticated &&
      [roles.SEGRETERIA_NAZIONALE].includes(profile!.role.name)
    ) {
      return PrivateElement;
    } else {
      return <Navigate replace to='/privato' />;
    }
  }

  return (
    <div className='w-full h-screen flex items-center justify-center'>
      <Spinner />
    </div>
  );
};

export default PrivateRouteOnlySecretary;
